/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the VirtualHealthLibraryApiConfiguration configuration object with a given root URL.
 */
export function provideVirtualHealthLibraryApiConfiguration(rootUrl: string) {
  var config = new VirtualHealthLibraryApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: VirtualHealthLibraryApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class VirtualHealthLibraryApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `VirtualHealthLibraryModule.forRoot()`
 */
export interface VirtualHealthLibraryApiConfigurationParams {
  rootUrl?: string;
}
